import React from 'react';
import { CSVLink } from 'react-csv'

const DownloadTemplateCsv = (props) => {

    const headers = [
        { label: 'Distribution', key: 'distribution' },
        { label: 'Net Cash Value', key: 'netCashValue' },
        { label: 'Net Death Benefits', key: 'netDeathBenefits' },
        { label: 'Premium Outlay', key: 'premiumOutlay' },
    ];
    const exampleData = [
        {
            'distribution': 0.0,
            'netCashValue': 0.0,
            'netDeathBenefits': 0.0,
            'premiumOutlay': 0.0
        }
    ]

    return <CSVLink
        headers={headers}
        data={exampleData}
        filename={"Guaranteed Income Template.csv"}
        className={"button-download-csv"}
    > Download Template
    </CSVLink>
}

export default DownloadTemplateCsv;